import { baseURL } from './config';
const Base = baseURL;

const URL = {
  fastReverse: Base + 'fast-reverse',
  autoComplete: Base + 'search/v2/autocomplete',
  tsp: Base + 'vrp/tsp/v1/driving',
  vrp: Base + 'route-optimization',
};

export default URL;
